// WATER USE TYPE
export const GET_WATER_USE_TYPES = '/water_use_type/query';
export const GET_WATER_USE_TYPE = '/water_use_type/';
export const POST_WATER_USE_TYPE = '/water_use_type/';
export const PUT_WATER_USE_TYPE = '/water_use_type/';
export const DELETE_WATER_USE_TYPE = '/water_use_type/';
export const CHECK_WATER_USE_TYPE_EXISTS = '/water_use_type/query';
